import React from 'react';
import {DefaultPage} from '../../../../../Components/DefaultPage';
import {ReadProgress} from '../../../../../Components/ReadProgress';
import {ArticleHeader} from '../../../../../Components/ArticleHeader';
import {ArticleBlock} from '../../../../../Components/ArticleBlock';
import {FinishArticle} from '../../../../../Components/FinishArticle';
import {HeadFC} from 'gatsby';
import {SEO} from '../../../../../Components/SEO';
import {ReciteQuran} from '../../../../../Components/ReciteQuran';
export default function AlcoraoLiteraturaOuRevelacao() {
  return (
    <DefaultPage>
      <ReadProgress />
      <ArticleHeader h1="O Alcorão: literaruta ou revelação?" h2="" />
      <div className="container">
        <ArticleBlock
          text={
            <>
              <p>
                Por vezes, a evolução intelectual atravessa pontes que, nem
                sempre, são seguras ou confiáveis, devido às dificuldades de
                percepção, compreensão e raciocínio que todos nós, humanos,
                possuímos, guardadas as proporções de mais ou de menos.
              </p>
              <p>
                A lucidez e o estudo são elementos de grande importância que,
                quando adicionados ao líquido da boa intenção, formam a
                argamassa necessária à edificação do sólido conhecimento humano
                que, por vezes, resta prejudicado, em consequência de, por
                exemplo, alguns estudarem a matéria cálculo estrutural em livros
                de culinária.
              </p>
              <p>
                A intelectualidade humana não deve estar dissociada da utilidade
                e do seu utilizador final, que devidamente direcionado para o
                fim a que se propõe, labora e progride, rumo ao conhecimento
                sadio e eficaz.
              </p>
              <p>
                Assim sendo, o verdadeiro conhecimento é indispensável e muito
                se distancia daquilo que possa ser identificado como “cultura
                inútil”.
              </p>
              <p>
                A transitoriedade dos fatos, isto é, o aspecto cronológico, ou
                temporal, dimensionando os acontecimentos, ora nesse período,
                ora naquele século, somente nos fazem confirmar a validade e a
                qualidade que identificam, e em que estão constituídos,
                efetivamente, os aprendizados que trafegam entre a teoria
                estudada e a prática realizada.
              </p>
              <p>
                A análise da problemática humana hoje, próxima do século XXI e
                do 3º milênio, demonstra, a quem quiser ver e enxergar, que o
                comportamento humano, ainda hoje, não se diferencia muito
                daquele havido na Idade da Pedra.
              </p>
              <p>
                As questões sociais de todo o complexo identificado como
                Sociedade Humana, formada por indivíduos, componentes de
                numerosas diversidades, apesar das teorias publicadas e
                pesquisadas, e ainda em fase de pesquisa, que são formuladas ao
                público das mais variadas maneiras, para todos os gostos, são a
                expressão do que conceitualmente poderíamos chamar de “Segunda
                Época” (aquele período em que o aluno, ao invés de entrar n gozo
                das férias, fica obrigado a rever e aprender tudo aquilo que não
                aprendeu em todo o ano letivo).
              </p>
              <p>
                As desigualdades, dia após dia, surgem como o cupim que corrói a
                Humanidade.
              </p>
              <p>
                Fatores como a fome, a violência, as doenças de diversos tipos e
                a adoção de medidas que tratam os sintomas, deixando de tratar a
                moléstia que os origina, por vezes nos fazem pensar que alguns
                acreditam que, se todos morrerem, não adoecerão mais.
              </p>
              <p>
                Quem de nós, ainda vivos, nos dias atuais, não vivenciou essa ou
                aquela problemática, esse ou aquele resultado da ignorância e do
                desconhecimento? Quem de nós, humanos, não viu esse ou aquele
                segmento identificado com “X”, “Y” ou “Z”, falar em nome dessa
                ou daquela teoria de ensino, desconhecendo efetivamente a
                disciplina sobre a qual acredita lecionar? Evidentemente, a
                validade do aprepndizado se depreende da sua aplicação ao longo
                da existência transcorrida na etapa da vida humana.
              </p>
              <p>
                Com a clareza desses pressupostos, podemos compreender que DEUS,
                o ALTÍSSIMO, o CLEMENTE, o MISERICORDIOSO, CRIADOR DE TODOS OS
                SERES E DE TODAS AS COISAS, permitiu e determinou a todos nós,
                criaturas, a SENDA RETA, isto é, o caminho que não leva aos
                abismos da ignorância. Para tanto, enviou a todos aqueles que
                têm boa vontade ou não, como ajuda e aviso, os ensinamentos do
                que é verdadeiro, do que é certo e do que é justo.
              </p>
              <p>
                Essa metodologia de vida, portada por muitos Profetas e vários
                Mensageiros de Deus, constitui o que se chama ISLAM, que não é
                uma salada de frutas de várias ideologias.
              </p>
              <p>
                Esse Sistema Completo de Vida, o ISLAM, que foi revelado à
                humanidade através de profetas, como aqueles da chamada Cadeia
                Semítica, sejam nominados como ADÃO, JONAS, JÓ, NOÉ, ABRAHÃO e
                seus filhos ISMAEL e ISAAC, DAVID, MOISÉS, JOÃO BATISTA, JESUS e
                MAOMÉ, ou de tantos outros quantos a humanidade não se preocupou
                em seus nomes preservar, como de outros oriundos de etnias,
                raças ou povos distantes, em épocas diferentes.
              </p>
              <p>
                O Alcorão Sagrado não é obra das criaturas, mas sim do CRIADOR,
                como tantas outras Mensagens Reveladas aos seres humanos, tal
                como o Torá, na forma original e intocável com a qual DEUS, o
                ALTÍSSIMO, determinou à humanidade, através de MOISÉS, o caminho
                da Retidão, como também foi apresentada nos Salmos revelados a
                DAVID, a expressão da Misericórdia do CRIADOR, também na forma
                original com que o Evangelho foi revelado a Jesus, filho de
                Maria.
              </p>
              <p>
                A Mensagem trazida à humanidade pelo Profeta e Mensageiro de
                Deus, Muhammad (Maomé) foi transmitida pelo Arcanjo Gabriel,
                aprendida através da tradição oral, e tal qual foi ouvida,
                recitada e confirmada, se encontra preservada, sem qualquer tipo
                de alteração ou reinterpretação e seus originais se encontram
                preservados e custodiados como confirmação de tudo isto.
              </p>
              <p>
                Diz DEUS, o Altíssimo nos versículos 2 a 5, da surata A Vaca:
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p></p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Eis o livro que é indubitavelmente a orientação dos
                      tementes a Deus;
                    </p>
                    <p>
                      que crêem no incognoscível, observam a oração e gastam
                      daquilo com que os agraciamos;
                    </p>
                    <p>
                      que crêm no que te foi revelado (revelado a Maomé), no que
                      foi revelado antes de ti e estão persuadidos da outra
                      vida.
                    </p>
                    <p>
                      Estes possuem a orientação do seu Senhor, e estes serão os
                      bem aventurados.
                    </p>
                  </>
                }
                quranIdex="2:2-5"
              />
              Ainda na surata A Vaca, nos versículos 37 e 38, lemos:
              <ReciteQuran
                arabicText={
                  <>
                    <p></p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      É impossível que este Alcorão tenha sido elaborado por
                      alguém que não seja Deus. Outrossim, é a confirmação das
                      revelações anteriores a ele e a elucidação do Livro
                      indubitável do Senhor do Universo.
                    </p>
                    <p>
                      Dizem (os que duvidam do milagre do Alcorão): Ele o
                      forjou! Dize: Componde pois, uma surata semelhante às
                      dele; e podeis recorrer, para isso, a quem quiserdes, em
                      vez de DEUS, se estiverdes certos.
                    </p>
                  </>
                }
                quranIdex="2:37-38"
              />
              Consequentemente, a expressão que alguns utilizam como sendo
              Literatura, em especial Literatura árabe, não se aplica ao milagre
              havido pela manifestação da Mensagem de DEUS revelada à
              humanidade, através do Mensageiro Maomé, no idioma árabe. O
              Alcorão, última Mensagem Revelada do ISLAM não foi, não é, não
              será, uma manifestação étnica ou de um agrupamento social. Na
              Surata Az Zúmar, versículos 27, 28 e 41, temos:
              <ReciteQuran
                arabicText={
                  <>
                    <p></p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      E expomos aos homens, neste Alcorão, toda a espécie de
                      exemplos para que meditem.
                    </p>
                    <p>
                      É um Alcorão árabe, irrepreensível, quiçá, assim temam a
                      Deus.
                    </p>
                  </>
                }
                quranIdex="39:27-28"
              />
              <ReciteQuran
                arabicText={
                  <>
                    <p></p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Em verdade, temos-te revelado o Livro para (instruíres) os
                      humanos. Assim, pois, quem se encaminhar será em benefício
                      próprio; por outra, quem se desviar, será em seu próprio
                      prejuízo.
                    </p>
                  </>
                }
                quranIdex="39:41"
              />
              <p>
                (1) Por outro lado, literatura é o resultado da consolidação de
                escritos, devidamente encadernados ou, ainda, de acordo com
                dicionários de língua portuguesa, dentre eles, o Novo Dicionário
                Enciclopédico Luso-Brasileiro, LELLO UNIVERSAL, de João Grave &
                Coelho Neto, publicado na cidade do Porto, Portugal, por LELLO e
                IRMÃO, que nos ensina o seguinte:
              </p>
              <p>
                LITTERATURA, ou LITERATURA, substantivo, feminino, do latim
                litteratura.
              </p>
              <p>
                Conhecimento das obras e das regras literárias, com
                especialidade as de eloquência e poesia.
              </p>
              <p>
                Carreira das letras, profissão do homem de letras, do escritor.
              </p>
              <p>
                Conjunto das produções literárias de um país, de uma época.”
                Além dessa temática, dentre muitas outras não estudadas, ou
                ditas sem compromisso com a razão, temos algumas afirmações,
                como por exemplo aquela que diz, dentre outros enganos, existir
                no Islam preceitos tais como “guerra santa”.
              </p>
              <p>
                O Fundamento do Islam está alicerçado nos seguintes Pilares:
              </p>
              <ol>
                <li>
                  crença na unicidade de DEUS, sabendo-se que não há outro deus
                  ou divindade além Dele;
                </li>
                <li>crença na existência dos anjos;</li>
                <li>
                  crença em que Deus enviou Profetas e Mensageiros para ensinar
                  à Humanidade o Caminho da Senda Reta;
                </li>
                <li>
                  crença nos Livros Revelados, desde que em suas formas
                  originais.
                </li>
              </ol>
              <p>
                Quanto aos Pilares da Prática do Islam, estes são representados
                pela obrigatoriedade da prática das orações, que são 5,
                diariamente; no cumprimento do jejum, de acordo com os
                parâmetros revelados durante o período do mês de Ramadan (9º mês
                do calendário lunar); no pagamento do zakat, que é uma
                importância tirada das quantias, dos estoques ou dos bens
                acumulados e sem utilização durante cada período anual, para
                distribuição aos necessitados; a obrigatoriedade da Peregrinação
                à Caaba, situada na cidade de Meca, na medida da possibilidade
                de cada pessoa.
              </p>
              <p>
                A própria utilização da expressão “guerra santa”, tem, quase
                sempre, origem nas fantasias vindas verdadeiramente da
                literatura humana, até e porque, para o muçulmano (palavra
                oriunda do vocábulo árabe “muslim”, que significa submisso),
                DEUS é o Único Santo e a Ele somos submissos.
              </p>
              <p>
                A necessidade e a obrigatoriedade, em havendo circunstâncias que
                autorizem qualquer tipo de luta, se dá, única e exclusivamente,
                pela defesa da dignidade humana e, nunca, como forma de opressão
                ou conquista com fins de dominação.
              </p>
              <p>
                Por último, gostaríamos de lembrar que muitas pessoas
                encontraram nos textos de Alcorão Sagrado fatos e detalhes,
                inclusive relativos às descobertas atuais da ciência humana, que
                ali já estavam relatadas há 1.400 anos atrás.
              </p>
              <p>
                Como exemplo, referenciamos a obra do eminente cientista
                francês, Prof. Dr. Maurice Bucaille, intitulada La Bible, Le
                Coran el la Science, editada em Paris, em 1987.
              </p>
              <p>
                Encerramos nossa palavra, conclamando a todos à obediência aos
                princípios estabelecidos por DEUS, o Altíssimo, lembrando suas
                palavras no 13º versículo da Surata dos Aposentos, no Al Acorão
                Sagrado, que são:
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p></p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Ó humanos, em verdade, Nós vos criamos de macho e fêmea e
                      vos dividimos em povos e tribos, para reconhecerdes uns
                      aos outros.Sabei que o mais honrado dentre vós, ante Deus,
                      é o mais temente. Sabei que Deus é Sapientíssimo e está
                      bem inteirado.
                    </p>
                  </>
                }
                quranIdex="49:13"
              />
            </>
          }
        />
      </div>
      <div className="footerNotes">
        <p>Por Haidar Abu Talib</p>
        <p>
          ===== (1) – Textos reproduzidos da obra O SIGNIFICADO DOS VERSÍCULOS
          DO ALCORÃO SAGRADO, do Prof. Samir El Hayek, Marshal Editora – SP,
          1984)
        </p>
      </div>
      <FinishArticle />
    </DefaultPage>
  );
}

export const Head: HeadFC = () => {
  return (
    <SEO
      title="Alcorão: literatura ou revelação? | Mesquita da Luz"
      description="A Mesquita da Luz, sede da Sociedade Beneficente Muçulmana do Rio de Janeiro, é um espaço dedicado à prática e difusão do Islamismo, localizada no Rio de Janeiro no bairro da Tijuca. Conheça nossos serviços, eventos e atividades. Seja bem-vindo!"
      // schema={indexSchema}
    />
  );
};
